/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { inject, OnDestroy, Pipe, PipeTransform } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { CountryStoreFacade, CountryVoModel } from "@well/common-libs/country-management/shell-api";

@Pipe({
  name: 'countryCodeToLabel',
  pure: false,
})
export class CountryCodeToLabelPipe implements PipeTransform, OnDestroy {
  private readonly countryStoreFacade = inject(CountryStoreFacade);

  private countries$: Observable<CountryVoModel[]> = this.countryStoreFacade.countries$;

  private countries: CountryVoModel[] | undefined = undefined;

  private destroy$: Subject<boolean> = new Subject();

  constructor() {
    this.countries$.pipe(takeUntil(this.destroy$)).subscribe((countries) => {
      this.countries = countries;
    });
  }

  transform(value: any, ...args: any[]): any {
    let country = null;
    if (value && this.countries && this.countries.length) {
      country = this.findCountry(value);
    }
    return country ? country.name : value;
  }

  private findCountry(code: any) {
    return this.countries?.find((country) => {
      return country.code === code;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
  }
}
